// import React, { useState } from 'react';
// import Layout from '../../Component/Layout/Layout';
// import '../../Styles/profile.css';

// const ProfileManage = () => {
//   const [activeTab, setActiveTab] = useState('profile');
//   const [profileData, setProfileData] = useState({
//     name: 'John Doe',
//     email: 'john.doe@example.com',
//     phone: '+91 98765 43210',
//     commissionRate: '15%',
//     referralCode: 'BUSINFLUENCE25',
//     bankName: 'State Bank of India',
//     accountNumber: 'XXXX XXXX 1234',
//     ifscCode: 'SBIN0000123',
//     accountHolder: 'John Doe'
//   });

//   const [originalProfileData] = useState({ ...profileData });

//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });

//   const [messages, setMessages] = useState({
//     profile: '',
//     password: '',
//     bank: ''
//   });

//   const [copySuccess, setCopySuccess] = useState(false);
//   const [isProfileChanged, setIsProfileChanged] = useState(false);
//   const [isBankChanged, setIsBankChanged] = useState(false);

//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfileData({
//       ...profileData,
//       [name]: value,
//     });
    
//     // Check if profile data has changed
//     const hasChanges = Object.keys(originalProfileData).some(key => {
//       if (['name', 'email', 'phone'].includes(key)) {
//         return profileData[key] !== originalProfileData[key];
//       }
//       return false;
//     });
//     setIsProfileChanged(hasChanges);
//   };

//   const handleBankChange = (e) => {
//     const { name, value } = e.target;
//     setProfileData({
//       ...profileData,
//       [name]: value,
//     });
    
//     // Check if bank data has changed
//     const hasChanges = Object.keys(originalProfileData).some(key => {
//       if (['bankName', 'accountNumber', 'ifscCode', 'accountHolder'].includes(key)) {
//         return profileData[key] !== originalProfileData[key];
//       }
//       return false;
//     });
//     setIsBankChanged(hasChanges);
//   };

//   const handlePasswordChange = (e) => {
//     setPasswordData({
//       ...passwordData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleCopyCode = () => {
//     navigator.clipboard.writeText(profileData.referralCode)
//       .then(() => {
//         setCopySuccess(true);
//         setTimeout(() => setCopySuccess(false), 2000);
//       })
//       .catch(err => {
//         setMessages({
//           ...messages,
//           profile: 'Failed to copy referral code'
//         });
//       });
//   };

//   const handleProfileSubmit = (e) => {
//     e.preventDefault();
    
//     // Simulate API call delay
//     setTimeout(() => {
//       setMessages({
//         ...messages,
//         profile: 'Profile updated successfully!'
//       });
//       setIsProfileChanged(false);
      
//       // Clear message after 3 seconds
//       setTimeout(() => {
//         setMessages({
//           ...messages,
//           profile: ''
//         });
//       }, 3000);
//     }, 1000);
//   };

//   const handlePasswordSubmit = (e) => {
//     e.preventDefault();
    
//     // Password validation
//     if (passwordData.newPassword.length < 8) {
//       setMessages({
//         ...messages,
//         password: 'Password must be at least 8 characters long'
//       });
//       return;
//     }

//     if (!/(?=.*[A-Z])/.test(passwordData.newPassword)) {
//       setMessages({
//         ...messages,
//         password: 'Password must contain at least one uppercase letter'
//       });
//       return;
//     }

//     if (!/(?=.*\d)/.test(passwordData.newPassword)) {
//       setMessages({
//         ...messages,
//         password: 'Password must contain at least one number'
//       });
//       return;
//     }

//     if (!/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(passwordData.newPassword)) {
//       setMessages({
//         ...messages,
//         password: 'Password must contain at least one special character'
//       });
//       return;
//     }

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setMessages({
//         ...messages,
//         password: 'New password and confirm password do not match'
//       });
//       return;
//     }

//     // Simulate API call delay
//     setTimeout(() => {
//       setMessages({
//         ...messages,
//         password: 'Password updated successfully!'
//       });
      
//       // Reset password fields
//       setPasswordData({
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: ''
//       });
      
//       // Clear message after 3 seconds
//       setTimeout(() => {
//         setMessages({
//           ...messages,
//           password: ''
//         });
//       }, 3000);
//     }, 1000);
//   };

//   const handleBankSubmit = (e) => {
//     e.preventDefault();
    
//     // Bank details validation
//     if (!profileData.bankName.trim()) {
//       setMessages({
//         ...messages,
//         bank: 'Bank name is required'
//       });
//       return;
//     }

//     if (!profileData.accountNumber.trim() || profileData.accountNumber.length < 8) {
//       setMessages({
//         ...messages,
//         bank: 'Valid account number is required'
//       });
//       return;
//     }

//     if (!profileData.ifscCode.trim() || profileData.ifscCode.length !== 11) {
//       setMessages({
//         ...messages,
//         bank: 'Valid IFSC code is required (11 characters)'
//       });
//       return;
//     }

//     if (!profileData.accountHolder.trim()) {
//       setMessages({
//         ...messages,
//         bank: 'Account holder name is required'
//       });
//       return;
//     }

//     // Simulate API call delay
//     setTimeout(() => {
//       setMessages({
//         ...messages,
//         bank: 'Bank details updated successfully!'
//       });
//       setIsBankChanged(false);
      
//       // Clear message after 3 seconds
//       setTimeout(() => {
//         setMessages({
//           ...messages,
//           bank: ''
//         });
//       }, 3000);
//     }, 1000);
//   };

//   const handleCancel = () => {
//     // Reset to original data
//     setProfileData({ ...originalProfileData });
//     setIsProfileChanged(false);
//     setIsBankChanged(false);
//     setMessages({
//       ...messages,
//       profile: 'Changes cancelled'
//     });
    
//     setTimeout(() => {
//       setMessages({
//         ...messages,
//         profile: ''
//       });
//     }, 2000);
//   };

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     // Clear messages when switching tabs
//     setMessages({
//       profile: '',
//       password: '',
//       bank: ''
//     });
//   };

//   return (
//     <Layout>
//       <div className="profile-page">
//         <div className="page-header">
//           <h1 className="page-title">Profile Management</h1>
//           <p className="page-subtitle">Manage your account settings and preferences</p>
//         </div>

//         <div className="profile-container">
//           {/* Tab Navigation */}
//           <div className="profile-tabs">
//             <button
//               className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
//               onClick={() => handleTabChange('profile')}
//             >
//               Profile Information
//             </button>
//             <button
//               className={`tab-btn ${activeTab === 'password' ? 'active' : ''}`}
//               onClick={() => handleTabChange('password')}
//             >
//               Change Password
//             </button>
//             <button
//               className={`tab-btn ${activeTab === 'bank' ? 'active' : ''}`}
//               onClick={() => handleTabChange('bank')}
//             >
//               Bank Details
//             </button>
//           </div>

//           {/* Profile Information Tab */}
//           {activeTab === 'profile' && (
//             <div className="tab-content">
//               {messages.profile && (
//                 <div className={`message ${messages.profile.includes('success') ? 'success' : 'info'}`}>
//                   {messages.profile}
//                 </div>
//               )}
              
//               <form onSubmit={handleProfileSubmit} className="profile-form">
//                 <div className="form-section">
//                   <h3 className="section-title">Personal Information</h3>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label htmlFor="name" className="form-label">
//                         Full Name
//                       </label>
//                       <input
//                         type="text"
//                         id="name"
//                         name="name"
//                         value={profileData.name}
//                         onChange={handleProfileChange}
//                         className="form-input"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="email" className="form-label">
//                         Email Address
//                       </label>
//                       <input
//                         type="email"
//                         id="email"
//                         name="email"
//                         value={profileData.email}
//                         onChange={handleProfileChange}
//                         className="form-input"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="phone" className="form-label">
//                         Phone Number
//                       </label>
//                       <input
//                         type="tel"
//                         id="phone"
//                         name="phone"
//                         value={profileData.phone}
//                         onChange={handleProfileChange}
//                         className="form-input"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="commissionRate" className="form-label">
//                         Commission Rate
//                       </label>
//                       <input
//                         type="text"
//                         id="commissionRate"
//                         name="commissionRate"
//                         value={profileData.commissionRate}
//                         className="form-input"
//                         disabled
//                       />
//                       <small className="form-help">
//                         Commission rate can only be changed by administrator
//                       </small>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="form-section">
//                   <h3 className="section-title">Referral Information</h3>
//                   <div className="referral-info">
//                     <div className="form-group">
//                       <label htmlFor="referralCode" className="form-label">
//                         Your Referral Code
//                       </label>
//                       <div className="referral-code-display">
//                         <code>{profileData.referralCode}</code>
//                         <button 
//                           type="button" 
//                           className={`copy-code-btn ${copySuccess ? 'copied' : ''}`}
//                           onClick={handleCopyCode}
//                         >
//                           {copySuccess ? '✓ Copied!' : 'Copy'}
//                         </button>
//                       </div>
//                       <small className="form-help">
//                         Share this code with your audience to earn commissions
//                       </small>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="form-actions">
//                   <button 
//                     type="submit" 
//                     className="save-btn"
//                     disabled={!isProfileChanged}
//                   >
//                     Save Changes
//                   </button>
//                   <button 
//                     type="button" 
//                     className="cancel-btn"
//                     onClick={handleCancel}
//                     disabled={!isProfileChanged}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           )}

//           {/* Change Password Tab */}
//           {activeTab === 'password' && (
//             <div className="tab-content">
//               {messages.password && (
//                 <div className={`message ${messages.password.includes('success') ? 'success' : 'error'}`}>
//                   {messages.password}
//                 </div>
//               )}
              
//               <form onSubmit={handlePasswordSubmit} className="password-form">
//                 <div className="form-section">
//                   <h3 className="section-title">Change Password</h3>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label htmlFor="currentPassword" className="form-label">
//                         Current Password
//                       </label>
//                       <input
//                         type="password"
//                         id="currentPassword"
//                         name="currentPassword"
//                         value={passwordData.currentPassword}
//                         onChange={handlePasswordChange}
//                         className="form-input"
//                         placeholder="Enter current password"
//                         required
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="newPassword" className="form-label">
//                         New Password
//                       </label>
//                       <input
//                         type="password"
//                         id="newPassword"
//                         name="newPassword"
//                         value={passwordData.newPassword}
//                         onChange={handlePasswordChange}
//                         className="form-input"
//                         placeholder="Enter new password"
//                         required
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="confirmPassword" className="form-label">
//                         Confirm New Password
//                       </label>
//                       <input
//                         type="password"
//                         id="confirmPassword"
//                         name="confirmPassword"
//                         value={passwordData.confirmPassword}
//                         onChange={handlePasswordChange}
//                         className="form-input"
//                         placeholder="Confirm new password"
//                         required
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="password-requirements">
//                   <h4>Password Requirements:</h4>
//                   <ul>
//                     <li className={passwordData.newPassword.length >= 8 ? 'met' : ''}>
//                       Minimum 8 characters
//                     </li>
//                     <li className={/(?=.*[A-Z])/.test(passwordData.newPassword) ? 'met' : ''}>
//                       At least one uppercase letter
//                     </li>
//                     <li className={/(?=.*\d)/.test(passwordData.newPassword) ? 'met' : ''}>
//                       At least one number
//                     </li>
//                     <li className={/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(passwordData.newPassword) ? 'met' : ''}>
//                       At least one special character
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="form-actions">
//                   <button 
//                     type="submit" 
//                     className="save-btn"
//                     disabled={!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword}
//                   >
//                     Update Password
//                   </button>
//                 </div>
//               </form>
//             </div>
//           )}

//           {/* Bank Details Tab */}
//           {activeTab === 'bank' && (
//             <div className="tab-content">
//               {messages.bank && (
//                 <div className={`message ${messages.bank.includes('success') ? 'success' : 'error'}`}>
//                   {messages.bank}
//                 </div>
//               )}
              
//               <form onSubmit={handleBankSubmit} className="bank-form">
//                 <div className="form-section">
//                   <h3 className="section-title">Bank Account Details</h3>
//                   <p className="section-subtitle">
//                     Provide your bank details to receive commission payments
//                   </p>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label htmlFor="bankName" className="form-label">
//                         Bank Name
//                       </label>
//                       <input
//                         type="text"
//                         id="bankName"
//                         name="bankName"
//                         value={profileData.bankName}
//                         onChange={handleBankChange}
//                         className="form-input"
//                         placeholder="Enter bank name"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="accountNumber" className="form-label">
//                         Account Number
//                       </label>
//                       <input
//                         type="text"
//                         id="accountNumber"
//                         name="accountNumber"
//                         value={profileData.accountNumber}
//                         onChange={handleBankChange}
//                         className="form-input"
//                         placeholder="Enter account number"
//                         maxLength="18"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="ifscCode" className="form-label">
//                         IFSC Code
//                       </label>
//                       <input
//                         type="text"
//                         id="ifscCode"
//                         name="ifscCode"
//                         value={profileData.ifscCode}
//                         onChange={handleBankChange}
//                         className="form-input"
//                         placeholder="Enter IFSC code"
//                         maxLength="11"
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label htmlFor="accountHolder" className="form-label">
//                         Account Holder Name
//                       </label>
//                       <input
//                         type="text"
//                         id="accountHolder"
//                         name="accountHolder"
//                         value={profileData.accountHolder}
//                         onChange={handleBankChange}
//                         className="form-input"
//                         placeholder="Enter account holder name"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="security-note">
//                   <div className="security-icon">🔒</div>
//                   <div className="security-text">
//                     <h4>Your bank details are secure</h4>
//                     <p>
//                       We use industry-standard encryption to protect your financial information.
//                       Your bank details are only used for processing commission payments.
//                     </p>
//                   </div>
//                 </div>

//                 <div className="form-actions">
//                   <button 
//                     type="submit" 
//                     className="save-btn"
//                     disabled={!isBankChanged}
//                   >
//                     Update Bank Details
//                   </button>
//                 </div>
//               </form>
//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default ProfileManage;

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../../Component/Layout/Layout';
import { 
  getInfluencerProfile, 
  updateInfluencerProfile, 
  changeInfluencerPassword,
  getInfluencerBankDetails,
  updateInfluencerBankDetails,
  deleteInfluencerBankDetails,
  getInfluencerDashboard,
  getInfluencerCommissions,
  getInfluencerPayments
} from '../../Services/Operations/ProductAPI';
import { updateProfileData } from '../../Redux/user_information';
import '../../Styles/profile.css';

const ProfileManage = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [profileData, setProfileData] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [commissionData, setCommissionData] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);
    const [isEditingBank, setIsEditingBank] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [editForm, setEditForm] = useState({
    name: '',
    phone: ''
  });
  
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  
  const [bankForm, setBankForm] = useState({});
  
  const [messages, setMessages] = useState({
    profile: '',
    password: '',
    bank: ''
  });

  const [copySuccess, setCopySuccess] = useState(false);
  const [isProfileChanged, setIsProfileChanged] = useState(false);
  const [isBankChanged, setIsBankChanged] = useState(false);

  const { token, loginData } = useSelector(state => state.influencer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      fetchProfileData();
      if (activeTab === 'dashboard') {
        fetchDashboardData();
      }
    }
  }, [token, activeTab]);

  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const response = await getInfluencerProfile(token);
      
      if (response.profile) {
        setProfileData(response.profile);
        setEditForm({
          name: response.profile.name || '',
          phone: response.profile.phone || ''
        });
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      setMessages(prev => ({
        ...prev,
        profile: 'Error fetching profile data'
      }));
    } finally {
      setLoading(false);
    }
  };

  const fetchDashboardData = async () => {
    try {
      const response = await getInfluencerDashboard(token);
      if (response) {
        setDashboardData(response);
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    }
  };

  const fetchBankDetails = async () => {
    try {
      const response = await getInfluencerBankDetails(token);
      if (response.success) {
        setBankDetails(response.bankDetails);
        setBankForm(response.bankDetails || {});
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
    }
  };

  const fetchCommissions = async () => {
    try {
      const response = await getInfluencerCommissions({}, token);
      if (response) {
        setCommissionData(response);
      }
    } catch (error) {
      console.error('Error fetching commissions:', error);
    }
  };

  const fetchPayments = async () => {
    try {
      const response = await getInfluencerPayments({}, token);
      if (response) {
        setPaymentData(response);
      }
    } catch (error) {
      console.error('Error fetching payments:', error);
    }
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Check if profile data has changed from original
    const hasChanges = profileData && (
      editForm.name !== profileData.name || 
      editForm.phone !== profileData.phone
    );
    setIsProfileChanged(hasChanges);
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setBankForm(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Check if bank data has changed from original
    const hasChanges = bankDetails && JSON.stringify(bankForm) !== JSON.stringify(bankDetails);
    setIsBankChanged(hasChanges);
  };

  const handlePasswordChange = (e) => {
    setPasswordForm({
      ...passwordForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleCopyCode = () => {
    if (profileData?.referralCode) {
      navigator.clipboard.writeText(profileData.referralCode)
        .then(() => {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        })
        .catch(err => {
          setMessages({
            ...messages,
            profile: 'Failed to copy referral code'
          });
        });
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      const response = await updateInfluencerProfile(editForm, token);
      
      if (response.success) {
        setProfileData(prev => ({ ...prev, ...response.profile }));
        dispatch(updateProfileData(response.profile));
        setMessages({
          ...messages,
          profile: 'Profile updated successfully!'
        });
        setIsProfileChanged(false);
        
        setTimeout(() => {
          setMessages(prev => ({ ...prev, profile: '' }));
        }, 3000);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      setMessages({
        ...messages,
        profile: error.response?.data?.message || 'Error updating profile'
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    
    // Password validation
    if (passwordForm.newPassword.length < 8) {
      setMessages({
        ...messages,
        password: 'Password must be at least 8 characters long'
      });
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setMessages({
        ...messages,
        password: 'New password and confirm password do not match'
      });
      return;
    }

    try {
      setLoading(true);
      const response = await changeInfluencerPassword({
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword
      }, token);
      
      if (response.success) {
        setMessages({
          ...messages,
          password: 'Password updated successfully!'
        });
        
        // Reset password fields
        setPasswordForm({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
        
        setTimeout(() => {
          setMessages(prev => ({ ...prev, password: '' }));
        }, 3000);
      }
    } catch (error) {
      console.error('Error changing password:', error);
      setMessages({
        ...messages,
        password: error.response?.data?.message || 'Error changing password'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBankSubmit = async (e) => {
    e.preventDefault();
    
    // Bank details validation
    if (!bankForm.accountHolderName?.trim()) {
      setMessages({
        ...messages,
        bank: 'Account holder name is required'
      });
      return;
    }

    if (!bankForm.accountNumber?.trim() || bankForm.accountNumber.length < 8) {
      setMessages({
        ...messages,
        bank: 'Valid account number is required'
      });
      return;
    }

    if (!bankForm.ifscCode?.trim() || bankForm.ifscCode.length !== 11) {
      setMessages({
        ...messages,
        bank: 'Valid IFSC code is required (11 characters)'
      });
      return;
    }

    if (!bankForm.bankName?.trim()) {
      setMessages({
        ...messages,
        bank: 'Bank name is required'
      });
      return;
    }

    try {
      setLoading(true);
      const response = await updateInfluencerBankDetails(bankForm, token);
      
      if (response.success) {
        setBankDetails(response.bankDetails);
        setMessages({
          ...messages,
          bank: 'Bank details updated successfully!'
        });
        setIsBankChanged(false);
        
        setTimeout(() => {
          setMessages(prev => ({ ...prev, bank: '' }));
        }, 3000);
      }
    } catch (error) {
      console.error('Error updating bank details:', error);
      setMessages({
        ...messages,
        bank: error.response?.data?.message || 'Error updating bank details'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBankDetails = async () => {
    if (window.confirm('Are you sure you want to delete your bank details?')) {
      try {
        const response = await deleteInfluencerBankDetails(token);
        if (response.success) {
          setBankDetails(null);
          setBankForm({});
          setMessages({
            ...messages,
            bank: 'Bank details deleted successfully!'
          });
          
          setTimeout(() => {
            setMessages(prev => ({ ...prev, bank: '' }));
          }, 3000);
        }
      } catch (error) {
        console.error('Error deleting bank details:', error);
        setMessages({
          ...messages,
          bank: error.response?.data?.message || 'Error deleting bank details'
        });
      }
    }
  };

  const handleCancel = () => {
    // Reset to original data
    if (profileData) {
      setEditForm({
        name: profileData.name || '',
        phone: profileData.phone || ''
      });
    }
    if (bankDetails) {
      setBankForm({ ...bankDetails });
    }
    setIsProfileChanged(false);
    setIsBankChanged(false);
    setMessages({
      ...messages,
      profile: 'Changes cancelled'
    });
    
    setTimeout(() => {
      setMessages(prev => ({ ...prev, profile: '' }));
    }, 2000);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Clear messages when switching tabs
    setMessages({
      profile: '',
      password: '',
      bank: ''
    });

    // Fetch data for specific tabs
    if (tab === 'bank' && !bankDetails) {
      fetchBankDetails();
    } else if (tab === 'commissions' && !commissionData) {
      fetchCommissions();
    } else if (tab === 'payments' && !paymentData) {
      fetchPayments();
    } else if (tab === 'dashboard' && !dashboardData) {
      fetchDashboardData();
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
    }).format(amount || 0);
  };

  if (loading && !profileData) {
    return (
      <Layout>
        <div className="profile-page">
          <div className="loading">Loading profile...</div>
        </div>
      </Layout>
    );
  }

  if (!profileData) {
    return (
      <Layout>
        <div className="profile-page">
          <div className="error">Error loading profile data</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="profile-page">
        <div className="page-header">
          <h1 className="page-title">Profile Management</h1>
          <p className="page-subtitle">Manage your account settings and preferences</p>
        </div>

        <div className="profile-container">
          {/* Tab Navigation */}
          <div className="profile-tabs">
            <button
              className={`tab-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => handleTabChange('dashboard')}
            >
              Dashboard
            </button>
            <button
              className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => handleTabChange('profile')}
            >
              Profile Information
            </button>
            <button
              className={`tab-btn ${activeTab === 'password' ? 'active' : ''}`}
              onClick={() => handleTabChange('password')}
            >
              Change Password
            </button>
            <button
              className={`tab-btn ${activeTab === 'bank' ? 'active' : ''}`}
              onClick={() => handleTabChange('bank')}
            >
              Bank Details
            </button>
          </div>

          {/* Dashboard Tab */}
          {activeTab === 'dashboard' && dashboardData && (
            <div className="tab-content">
              <div className="dashboard-stats">
                <div className="stat-cards">
                  <div className="stat-card">
                    <h3>Total Earnings</h3>
                    <p>{formatCurrency(dashboardData.stats?.totalEarnings)}</p>
                    <span>All time earnings</span>
                  </div>
                  <div className="stat-card">
                    <h3>Pending Payout</h3>
                    <p>{formatCurrency(dashboardData.stats?.pendingEarnings)}</p>
                    <span>Awaiting payment</span>
                  </div>
                  <div className="stat-card">
                    <h3>Total Referrals</h3>
                    <p>{dashboardData.stats?.totalReferrals || 0}</p>
                    <span>Successful bookings</span>
                  </div>
                  <div className="stat-card">
                    <h3>Commission Rate</h3>
                    <p>{dashboardData.stats?.commissionRate || profileData.commissionRate}%</p>
                    <span>Your rate</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Profile Information Tab */}
          {activeTab === 'profile' && (
            <div className="tab-content">
              {messages.profile && (
                <div className={`message ${messages.profile.includes('success') ? 'success' : 'error'}`}>
                  {messages.profile}
                </div>
              )}
              
              <form onSubmit={handleProfileSubmit} className="profile-form">
                <div className="form-section">
                  <h3 className="section-title">Personal Information</h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={editForm.name}
                        onChange={handleProfileChange}
                        className="form-input"
                        placeholder="Enter your full name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        value={profileData.email}
                        className="form-input"
                        disabled
                      />
                      <small className="form-help">
                        Email cannot be changed
                      </small>
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={editForm.phone}
                        onChange={handleProfileChange}
                        className="form-input"
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="commissionRate" className="form-label">
                        Commission Rate
                      </label>
                      <input
                        type="text"
                        id="commissionRate"
                        value={`${profileData.commissionRate}%`}
                        className="form-input"
                        disabled
                      />
                      <small className="form-help">
                        Commission rate can only be changed by administrator
                      </small>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h3 className="section-title">Referral Information</h3>
                  <div className="referral-info">
                    <div className="form-group">
                      <label htmlFor="referralCode" className="form-label">
                        Your Referral Code
                      </label>
                      <div className="referral-code-display">
                        <code>{profileData.referralCode}</code>
                        <button 
                          type="button" 
                          className={`copy-code-btn ${copySuccess ? 'copied' : ''}`}
                          onClick={handleCopyCode}
                        >
                          {copySuccess ? '✓ Copied!' : 'Copy'}
                        </button>
                      </div>
                      <small className="form-help">
                        Share this code with your audience to earn commissions
                      </small>
                    </div>
                  </div>
                </div>

                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="save-btn"
                    disabled={!isProfileChanged || loading}
                  >
                    {loading ? 'Saving...' : 'Save Changes'}
                  </button>
                  <button 
                    type="button" 
                    className="cancel-btn"
                    onClick={handleCancel}
                    disabled={!isProfileChanged || loading}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Change Password Tab */}
          {activeTab === 'password' && (
            <div className="tab-content">
              {messages.password && (
                <div className={`message ${messages.password.includes('success') ? 'success' : 'error'}`}>
                  {messages.password}
                </div>
              )}
              
              <form onSubmit={handlePasswordSubmit} className="password-form">
                <div className="form-section">
                  <h3 className="section-title">Change Password</h3>
                  <div className="form-grid">
                    <div className="form-group">
                      <label htmlFor="currentPassword" className="form-label">
                        Current Password
                      </label>
                      <input
                        type="password"
                        id="currentPassword"
                        name="currentPassword"
                        value={passwordForm.currentPassword}
                        onChange={handlePasswordChange}
                        className="form-input"
                        placeholder="Enter current password"
                        required
                        disabled={loading}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="newPassword" className="form-label">
                        New Password
                      </label>
                      <input
                        type="password"
                        id="newPassword"
                        name="newPassword"
                        value={passwordForm.newPassword}
                        onChange={handlePasswordChange}
                        className="form-input"
                        placeholder="Enter new password"
                        required
                        disabled={loading}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="confirmPassword" className="form-label">
                        Confirm New Password
                      </label>
                      <input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={passwordForm.confirmPassword}
                        onChange={handlePasswordChange}
                        className="form-input"
                        placeholder="Confirm new password"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>

                <div className="password-requirements">
                  <h4>Password Requirements:</h4>
                  <ul>
                    <li className={passwordForm.newPassword.length >= 8 ? 'met' : ''}>
                      Minimum 8 characters
                    </li>
                    <li className={/(?=.*[A-Z])/.test(passwordForm.newPassword) ? 'met' : ''}>
                      At least one uppercase letter
                    </li>
                    <li className={/(?=.*\d)/.test(passwordForm.newPassword) ? 'met' : ''}>
                      At least one number
                    </li>
                    <li className={/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(passwordForm.newPassword) ? 'met' : ''}>
                      At least one special character
                    </li>
                  </ul>
                </div>

                <div className="form-actions">
                  <button 
                    type="submit" 
                    className="save-btn"
                    disabled={!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword || loading}
                  >
                    {loading ? 'Updating...' : 'Update Password'}
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Bank Details Tab */}
          {activeTab === 'bank' && (
            <div className="tab-content">
              {messages.bank && (
                <div className={`message ${messages.bank.includes('success') ? 'success' : 'error'}`}>
                  {messages.bank}
                </div>
              )}
              
              {!bankDetails ? (
                <div className="no-bank-details">
                  <p>No bank details added yet.</p>
                  <button 
                    className="add-bank-btn"
                    onClick={() => {
                      setBankForm({});
                      setIsEditingBank(true);
                    }}
                    disabled={loading}
                  >
                    Add Bank Details
                  </button>
                </div>
              ) : (
                <form onSubmit={handleBankSubmit} className="bank-form">
                  <div className="form-section">
                    <h3 className="section-title">Bank Account Details</h3>
                    <p className="section-subtitle">
                      Provide your bank details to receive commission payments
                    </p>
                    <div className="form-grid">
                      <div className="form-group">
                        <label htmlFor="accountHolderName" className="form-label">
                          Account Holder Name
                        </label>
                        <input
                          type="text"
                          id="accountHolderName"
                          name="accountHolderName"
                          value={bankForm.accountHolderName || ''}
                          onChange={handleBankChange}
                          className="form-input"
                          placeholder="Enter account holder name"
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="accountNumber" className="form-label">
                          Account Number
                        </label>
                        <input
                          type="text"
                          id="accountNumber"
                          name="accountNumber"
                          value={bankForm.accountNumber || ''}
                          onChange={handleBankChange}
                          className="form-input"
                          placeholder="Enter account number"
                          maxLength="18"
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="ifscCode" className="form-label">
                          IFSC Code
                        </label>
                        <input
                          type="text"
                          id="ifscCode"
                          name="ifscCode"
                          value={bankForm.ifscCode || ''}
                          onChange={handleBankChange}
                          className="form-input"
                          placeholder="Enter IFSC code"
                          maxLength="11"
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="bankName" className="form-label">
                          Bank Name
                        </label>
                        <input
                          type="text"
                          id="bankName"
                          name="bankName"
                          value={bankForm.bankName || ''}
                          onChange={handleBankChange}
                          className="form-input"
                          placeholder="Enter bank name"
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="branchName" className="form-label">
                          Branch Name
                        </label>
                        <input
                          type="text"
                          id="branchName"
                          name="branchName"
                          value={bankForm.branchName || ''}
                          onChange={handleBankChange}
                          className="form-input"
                          placeholder="Enter branch name"
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="accountType" className="form-label">
                          Account Type
                        </label>
                        <select
                          id="accountType"
                          name="accountType"
                          value={bankForm.accountType || 'savings'}
                          onChange={handleBankChange}
                          className="form-select"
                          disabled={loading}
                        >
                          <option value="savings">Savings</option>
                          <option value="current">Current</option>
                          <option value="salary">Salary</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="security-note">
                    <div className="security-icon">🔒</div>
                    <div className="security-text">
                      <h4>Your bank details are secure</h4>
                      <p>
                        We use industry-standard encryption to protect your financial information.
                        Your bank details are only used for processing commission payments.
                      </p>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button 
                      type="submit" 
                      className="save-btn"
                      disabled={!isBankChanged || loading}
                    >
                      {loading ? 'Updating...' : 'Update Bank Details'}
                    </button>
                    <button 
                      type="button" 
                      className="delete-btn"
                      onClick={handleDeleteBankDetails}
                      disabled={loading}
                    >
                      Delete Bank Details
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ProfileManage;